export enum LabelForKey {
    area = 'Área',
    declared_area = 'Área declarada',
    crop_type = 'Tipo de cultivo',
    department = 'Departamento',
    province = 'Provincia',
    name = 'Nombre',
    campaign = 'Campaña',
    creation_date = 'Fecha denuncia', //fecha denuncia
    claim_id = "Nº denuncia",
    event_type = "Tipo evento",
    event_date = "Fecha evento"
}